export default "__VITE_ASSET__g7yZ_$W3__"